"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNotificationDto = void 0;
class CreateNotificationDto {
    category;
    data;
    display_id;
    expiration;
    from;
    campaign_request_id;
    media_campaign_id;
    media_id;
    message;
    subject;
    subcategory;
    to;
}
exports.CreateNotificationDto = CreateNotificationDto;
